import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getAllOrganizedUnit from '../../services/organizedUnit/getAllOrganizedUnits'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchOrganizedUnitsComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchOrganizedUnitsCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const UOCombo = yield call(getAllOrganizedUnit, auth.token)
    yield put(fetchOrganizedUnitsComboSuccess(UOCombo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchOrganizedUnitsCombo () {
  yield takeLatest(combosActionTypes.FETCH_ORGANIZED_UNITS_COMBO, fetchOrganizedUnitsCombo)
}
